import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';

// services
import { PartnerBrandService } from '@campfire-nx/api';
import { UserDataService } from '../services/user-data.service';
import { PolicyDetailsService } from '../services/policy-details.service';

@Injectable({
  providedIn: 'root'
})
export class PolicyResolver implements Resolve<boolean> {

  constructor(
    private router: Router,
    private userDataService: UserDataService,
    private policyDetailsService: PolicyDetailsService,
    private partnerBrandService: PartnerBrandService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<any> {
    const { productClass, uuid } = route.params;
     return this.userDataService.getUserData()
      .then((response: any) => {
        const { policies } = response;
        let filteredPolicy;

        // look through raptor policies first
        for (const [key, value] of Object.entries(policies.raptor)) {
          filteredPolicy = policies.raptor.find((policy: { [key: string]: any }) => policy.uuid === uuid);
        }

        // look through legacy policies if filteredPolicy is not set from above loop
        if (!filteredPolicy ) {
          for (const [key, value] of Object.entries(policies[productClass])) {
            filteredPolicy = policies[productClass].find((policy: { [key: string]: any }) => policy.slug === uuid);
          }
        }

        // After above 2 iterations filteredPolicy should definitely be set
        if (filteredPolicy) {
          this.policyDetailsService.policy = filteredPolicy;

          // Ensure the product attribute is set for Need Help? link within the Header and Footer
          this.partnerBrandService.setAttribute('product', filteredPolicy.product, 'partner');

          return filteredPolicy;
        }

        // redirect to 404 if no policy
        this.router.navigate(['/not-found']);
      });
  }
}
